import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import CategoryHub from "@/pages/CategoryHub";
import TeamUpload from "@/pages/TeamUpload";
import BusinessDetail from "@/pages/BusinessDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Offers from "@/pages/Offers";
import OfferDetail from "@/pages/OfferDetail";
import Promotions from "@/pages/Promotions";
import PromotionDetail from "@/pages/PromotionDetail";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import OperatorProfile from "@/pages/operator/OperatorProfile";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import About from "@/pages/About";
import Join from "@/pages/Join";
import Advertise from "@/pages/Advertise";
import Contest from "@/pages/Contest";
import WinnersHall from "@/pages/WinnersHall";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import OwnerAuth from "@/pages/owner/OwnerAuth";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import OperatorDashboard from "@/pages/operator/OperatorDashboard";
import CustomerAuth from "@/pages/customer/CustomerAuth";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/owner/PaymentResult";

const Public = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/directory" element={<Public><Directory /></Public>} />
          <Route path="/explore/:section" element={<Public><CategoryHub /></Public>} />
          <Route path="/team" element={<TeamUpload />} />
          <Route path="/directory/:slug" element={<Public><BusinessDetail /></Public>} />
          <Route path="/events" element={<Public><Events /></Public>} />
          <Route path="/events/:slug" element={<Public><EventDetail /></Public>} />
          <Route path="/offers" element={<Public><Offers /></Public>} />
          <Route path="/offers/:slug" element={<Public><OfferDetail /></Public>} />
          <Route path="/promotions" element={<Public><Promotions /></Public>} />
          <Route path="/promotions/:slug" element={<Public><PromotionDetail /></Public>} />
          <Route path="/contest" element={<Public><Contest /></Public>} />
          <Route path="/contest/winners" element={<Public><WinnersHall /></Public>} />
          <Route path="/tours" element={<Public><Tours /></Public>} />
          <Route path="/tours/:slug" element={<Public><TourDetail /></Public>} />
          <Route path="/operators/:slug" element={<Public><OperatorProfile /></Public>} />
          <Route path="/guides" element={<Public><Guides /></Public>} />
          <Route path="/guides/:slug" element={<Public><GuideDetail /></Public>} />
          <Route path="/about" element={<Public><About /></Public>} />
          <Route path="/join" element={<Public><Join /></Public>} />
          <Route path="/advertise" element={<Public><Advertise /></Public>} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/owner/login" element={<OwnerAuth />} />
          <Route path="/owner" element={<OwnerDashboard />} />
          <Route path="/operator" element={<OperatorDashboard />} />
          <Route path="/account/login" element={<CustomerAuth />} />
          <Route path="/account" element={<CustomerDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
